import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import actions from './actions';

import ListaAcoes from '../../components/ListaAcoes';
import constants from './constants';

class ListaContratrantes extends Component {
  render() {
    let { value, actions } = this.props;

    return (
      <ListaAcoes
        title="Contratantes"
        value={value}
        actions={{
          onLoad: actions.onLoadListContratantes,
          onCancel: actions.onChangeListContratantes(
            constants.Status.CANCELADA
          ),
          onApprove: actions.onChangeListContratantes(
            constants.Status.CONFIRMADA
          ),
          onCreate: actions.onChangeListContratantes(
            constants.Status.CONFIRMADA
          )
        }}
        labelFn={item => item.apartamento + ' ' + item.nome}
      />
    );
  }
}

let mapStateToProps = ({ admin: { contratantes } }) => ({
  value: contratantes
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaContratrantes);



// WEBPACK FOOTER //
// ./src/modules/admin/ListaContratantes.js